import { render } from "./StoreSpecialDesignation.vue?vue&type=template&id=78b96138&scoped=true"
import script from "./StoreSpecialDesignation.vue?vue&type=script&lang=js"
export * from "./StoreSpecialDesignation.vue?vue&type=script&lang=js"

import "./StoreSpecialDesignation.vue?vue&type=style&index=0&id=78b96138&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78b96138"

export default script